import { useEffect } from 'react'
import { useFlag, useFlagsStatus, useUnleashContext, useVariant } from '@unleash/proxy-client-react'

import { usePersonalUserData } from './usePersonalUserData'

import { IUnleashFlag, IFlagStatus } from './types'

const useUnleashUserContext = () => {
  const { userEmail, userPlanCode, userRole } = usePersonalUserData()
  const updateContext = useUnleashContext()

  useEffect(() => {
    void updateContext({
      userId: userEmail,
      properties: { planCode: userPlanCode, userRole },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userEmail, userPlanCode, userRole])
}

export const useUnleashFlag = (featureName: string): IUnleashFlag => {
  const isFlagEnabled = useFlag(featureName)
  const status: IFlagStatus = useFlagsStatus()
  useUnleashUserContext()

  const hasError = !!status.flagsError?.message
  const showFeature = !hasError && status.flagsReady && isFlagEnabled

  return {
    showFeature
  }
}

export const useUnleashVariant = (flagName: string) => {
  useUnleashUserContext()

  return useVariant(flagName)
}
